<template>
  <div class="password-reset-view pa-4">
    <p class="text-h6 mb-2">
      Redefinir senha
    </p>

    <p class="text-caption mb-0">
      Por favor, cadastre uma nova senha para acessar o portal.
    </p>

    <password-reset-form
      :loading="isSendingInfo"
      @submit="(fields) => resetPassword(fields.password)"
    />
  </div>
</template>

<script>
import store from '@/services/store';
import router from '@/services/router';

import api from '../utils/guest-api';
import { getLoginFailureOptions } from '../utils/error-utils';

import PasswordResetForm from '../components/PasswordResetForm.vue';

export default {
  name: 'PasswordResetView',

  components: {
    PasswordResetForm,
  },

  data: () => ({
    isSendingInfo: false,
  }),

  methods: {
    async resetPassword(password) {
      this.isSendingInfo = true;

      try {
        const { resetToken } = router.currentRoute.query;

        await api.auth.resetPassword({ resetToken, password });

        store.dispatch('alert/showAlert', {
          icon: 'mdi-check',
          iconColor: 'success',
          title: 'Senha alterada com sucesso!',
          message: 'Utilize sua nova senha para entrar no sistema.',
        });

        router.push('/login');
      } catch (error) {
        store.dispatch('alert/showAlert', getLoginFailureOptions(error));
      } finally {
        this.isSendingInfo = false;
      }
    },
  },
};
</script>
